import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import { useAddLogInformationMutation } from '../../store/api/logInformationApi'
import { hideLogDialog } from '../../store/slice/dialogSlice'
import moment from "moment";

const LogDialog = ({ id,loading }) => {
    const path = window.location.pathname
    const urlId = path.substring(path.lastIndexOf('/') + 1)
    const { dataId } = useParams()

    const open = useSelector((state) => state.dialogSlice.logDialog)
    const dispatch = useDispatch()
    const handleClose = () => {
        dispatch(hideLogDialog())
    }

    const requestData = useSelector((state) => state.persistSlice.requestData)
    const userData = useSelector((state) => state.mainToCard.userData)
    const groupData = useSelector((state) => state.mainToCard.groupData)
    const vendorData = useSelector((state) => state.mainToCard.vendorData)
    const rfqsData = useSelector((state) => state.mainToCard.rfqsData)
    const orderData = useSelector((state) => state.mainToCard.orderData)
    const analysisStructureData = useSelector((state) => state.mainToCard.analysisStructureData)
    const analysisDimensionData = useSelector((state) => state.mainToCard.analysisDimensionData)
    const analysisCodeData = useSelector((state) => state.mainToCard.analysisCodeData)
    const bidsData = useSelector((state) => state.mainToCard.bidsData)
    const approvalRolesData = useSelector((state) => state.mainToCard.approvalRolesData)
    const approvalStageData = useSelector((state) => state.mainToCard.approvalStageData)
    const selectedBidComparsionGridData = useSelector((state) => state.bidComparsionSlice.selectedGridData)
    const comparsionChartData = useSelector((state) => state.bidComparsionSlice.comparsionChartData)
    const paymentDataSlice = useSelector((state) => state.persistSlice.paymentData)
    const invoiceMain = useSelector((state) => state.mainToCard.invoiceMain)


    const url = useLocation().pathname
    const [addLogInformation, { data, isLoading }] = useAddLogInformationMutation()
    useEffect(() => {
        switch (url) {
            case '/users':
                addLogInformation({
                    id: userData[0] ? userData[0].id : 0,
                    logType: 1,
                })
                break
            case '/groups':
                addLogInformation({
                    id: groupData[0] ? groupData[0].groupId : 0,
                    logType: 2,
                })
                break
            case '/approval-roles':
                addLogInformation({
                    id: approvalRolesData[0] ? approvalRolesData[0].approveRoleId : 0,
                    logType: 13,
                })
                break
            case '/rfqs':
                addLogInformation({
                    id: rfqsData[0] ? rfqsData[0].id : 0,
                    logType: 14,
                })
                break
            case `/rfqs/${urlId}`:
                addLogInformation({
                    id: rfqsData[0] ? rfqsData[0].id : urlId,
                    logType: 14,
                })
                break
            case '/bids':
                addLogInformation({
                    id: bidsData?.id ?? 0,
                    logType: 15,
                })
                break

            case `/bids/${urlId}`:
                addLogInformation({
                    id: bidsData?.[0] ? bidsData?.[0]?.id : urlId,
                    logType: 15,
                })
                break
            case '/bid-comparison':
                addLogInformation({
                    id: selectedBidComparsionGridData?.[0]?.bidComparisonId,
                    logType: 16,
                })
                break
            case `/bid-comparison/${urlId}`:
                comparsionChartData?.bidComparisonHeader?.bidComparisonId && addLogInformation({
                    id: comparsionChartData?.bidComparisonHeader?.bidComparisonId,
                    logType: 16,
                })
                break
            case `/invoice-register`:
                addLogInformation({
                    id: invoiceMain[0]?.invoiceRegisterId,
                    logType: 18,
                })
                break
            case '/approval-stages':
                addLogInformation({
                    id: approvalStageData[0] ? approvalStageData[0].id : 0,
                    logType: 4,
                })
                break
            case `/approval-stages/${urlId}`:
                addLogInformation({
                    id: urlId || 0,
                    logType: 4,
                })
                break
            case '/vendors':
                addLogInformation({
                    id: vendorData[0] ? vendorData[0].vendorId : 0,
                    logType: 6,
                })
                break
            case '/analysis-structures':
                addLogInformation({
                    id: analysisStructureData?.[0] ? analysisStructureData[0].analysisStructureId : 0,
                    logType: 10,
                })
                break

            case '/analysis-dimensions':
                addLogInformation({
                    id: analysisDimensionData?.[0] ? analysisDimensionData[0].analysisDimensionId : 0,
                    logType: 8,
                })
                break

            case '/analysis-codes':
                addLogInformation({
                    id: analysisCodeData?.[0] ? analysisCodeData[0].analysisCodesId : 0,
                    logType: 9,
                })
                break
            case `/vendors/${dataId}`:
                addLogInformation({
                    id: dataId,
                    logType: 6,
                })
                break
            case '/requests':
                addLogInformation({
                    id: requestData?.[0] ? requestData?.[0]?.requestMainId : 0,
                    logType: 7,
                })
                break
            case `/requests/${urlId}`:
                addLogInformation({
                    id: urlId || 0,
                    logType: 7,
                })
                break

            case '/orders':
                addLogInformation({
                    id: orderData[0] ? orderData[0]?.orderMainId : 0,
                    logType: 17,
                })
                break
            case `/orders/${dataId}`:
                addLogInformation({
                    id: dataId || 0,
                    logType: 17,
                })
                break

          
            default:
                break
        }
    }, [
        addLogInformation,
        userData,
        rfqsData,
        orderData,
        dataId,
        requestData,
        groupData,
        approvalRolesData,
        approvalStageData,
        url,
        urlId,
        vendorData,
        analysisCodeData,
        analysisDimensionData,
        analysisStructureData,
        bidsData,
        id,loading,
        comparsionChartData,
        selectedBidComparsionGridData, invoiceMain, paymentDataSlice
    ])

    const [tableData, setTableData] = useState([])

    useEffect(() => {
        if (!isLoading) {
            setTableData(data?.data)
        }
    }, [isLoading, data])



    return (
        <div>
            <Dialog open={open} onClose={handleClose} maxWidth="1000px">
                <DialogTitle>Log Information</DialogTitle>
                <Divider />
                <DialogContent>
                    <Box sx={{ height: 400, width: 1000 }}>

                        <DataGrid
                            getRowId={getRowId}
                            rows={tableData || []}
                            columns={columns}
                            components={{
                                Toolbar: GridToolbar,
                            }}
                        />

                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose} sx={{ color: 'gray', borderColor: '#D3D3D3' }}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default LogDialog

function getRowId(row) {
    return row.logId
}

const columns = [
    {
        field: 'actionName',
        headerName: 'Action',
        headerAlign: 'center',
        align: 'center',
        width: 100,
        editable: false,
    },
    {
        field: 'fullName',
        headerName: 'Full Name',
        headerAlign: 'center',
        align: 'center',
        width: 150,
        editable: false,
    },
    {
        field: 'logInformation',
        headerName: 'Log Information',
        headerAlign: 'center',
        align: 'center',
        width: 200,
        editable: false,
    },
    {
        field: 'date',
        headerName: 'Date',
        type: 'date',
        headerAlign: 'center',
        align: 'center',
        width: 120,
        editable: false,
        valueFormatter: (params) => {
            return moment(params.value).format('DD.MM.YYYY HH:mm')
        },
    },
]

